<script setup>
import { useLayout } from '@/layout/common/composables/layout';
import { cva } from 'class-variance-authority';
import { computed } from 'vue';
const props = defineProps({
    class: {
        type: String,
        default: ''
    }
});

const { layoutConfig, calculatedMenuMode, toggleAnchored, onClose } = useLayout();

const handleToggleAnchored = (event) => {
    event.preventDefault();
    event.stopPropagation();
    toggleAnchored();
};

const sidebarHeaderVariants = cva('relative flex items-center gap-3 p-4 [&_span]:whitespace-nowrap [&_span]:transition-all', {
    variants: {
        variant: {
            compact: 'w-9 h-16 !p-1.5 !pt-6 [&_span]:opacity-0 mx-auto',
            slim: 'w-9 h-16 !p-1.5 !pt-6 [&_span]:opacity-0 mx-auto',
            horizontal: '!py-0',
            drawer: 'w-full h-16 !p-2.5 !py-4 group-data-[state=collapsed]/sidebar-wrapper:justify-center group-data-[state=collapsed]/sidebar-wrapper:!px-0 group-data-[state=collapsed]/sidebar-wrapper:[&_svg]:size-7 group-data-[state=collapsed]/sidebar-wrapper:[&_span]:opacity-0',
            reveal: 'w-full h-16 !p-2.5 !py-4 group-data-[state=collapsed]/sidebar-wrapper:justify-center group-data-[state=collapsed]/sidebar-wrapper:!px-0 group-data-[state=collapsed]/sidebar-wrapper:[&_svg]:size-7 group-data-[state=collapsed]/sidebar-wrapper:[&_span]:opacity-0'
        }
    }
});

const sidebarHeaderClass = computed(() => {
    return sidebarHeaderVariants({
        variant: calculatedMenuMode.value,
        class: props.class
    });
});
</script>
<template>
    <div :class="sidebarHeaderClass">
        <slot />
        <button type="button" v-if="calculatedMenuMode === 'overlay'" @click="onClose" class="absolute right-6 top-1/2 -translate-y-1/2 w-6 h-6 rounded-md border hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors duration-200">
            <i class="pi pi-times !text-xs" />
        </button>
        <button
            type="button"
            v-if="calculatedMenuMode === 'drawer' || calculatedMenuMode === 'reveal'"
            @click="handleToggleAnchored"
            :aria-pressed="layoutConfig.anchored"
            :title="layoutConfig.anchored ? 'Unpin sidebar' : 'Pin sidebar'"
            class="absolute right-4 top-1/2 z-20 h-5 w-5 -translate-y-1/2 rounded-full border-2 border-surface-300 bg-primary-900/80 transition-all duration-200 ease-out before:absolute before:-inset-2 before:rounded-full after:absolute after:inset-1 after:rounded-full after:bg-surface-100 after:transition-all after:duration-200 hover:scale-105 hover:border-white/80 hover:after:opacity-70 active:scale-95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white dark:border-surface-600 dark:bg-surface-900 group-data-[state=collapsed]/sidebar-wrapper:pointer-events-none group-data-[state=collapsed]/sidebar-wrapper:opacity-0 group-data-[state=collapsed]/sidebar-wrapper:duration-0"
            :class="layoutConfig.anchored ? 'border-white after:scale-100 after:opacity-100' : 'after:scale-75 after:opacity-0'"
        />
    </div>
</template>
